/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainSettingsAdvertisementGtagForDomainOptions } from './FxIdDomainSettingsAdvertisementGtagForDomainOptions';
import {
    instanceOfFxIdDomainSettingsAdvertisementGtagForDomainOptions,
    FxIdDomainSettingsAdvertisementGtagForDomainOptionsFromJSON,
    FxIdDomainSettingsAdvertisementGtagForDomainOptionsFromJSONTyped,
    FxIdDomainSettingsAdvertisementGtagForDomainOptionsToJSON,
} from './FxIdDomainSettingsAdvertisementGtagForDomainOptions';

/**
 * @type FxIdDomainSettingsAdvertisementGtagOptionsDefault
 * Настройки для всех доменов игры по умолчанию. Может быть не указан.
 * @export
 */
export type FxIdDomainSettingsAdvertisementGtagOptionsDefault = FxIdDomainSettingsAdvertisementGtagForDomainOptions;

export function FxIdDomainSettingsAdvertisementGtagOptionsDefaultFromJSON(json: any): FxIdDomainSettingsAdvertisementGtagOptionsDefault {
    return FxIdDomainSettingsAdvertisementGtagOptionsDefaultFromJSONTyped(json, false);
}

export function FxIdDomainSettingsAdvertisementGtagOptionsDefaultFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsAdvertisementGtagOptionsDefault {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsAdvertisementGtagForDomainOptions(json)) {
        return FxIdDomainSettingsAdvertisementGtagForDomainOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdDomainSettingsAdvertisementGtagOptionsDefaultToJSON(json: any): any {
    return FxIdDomainSettingsAdvertisementGtagOptionsDefaultToJSONTyped(json, false);
}

export function FxIdDomainSettingsAdvertisementGtagOptionsDefaultToJSONTyped(value?: FxIdDomainSettingsAdvertisementGtagOptionsDefault | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainSettingsAdvertisementGtagForDomainOptions(value)) {
        return FxIdDomainSettingsAdvertisementGtagForDomainOptionsToJSON(value as FxIdDomainSettingsAdvertisementGtagForDomainOptions);
    }

    return {};
}

